import React from 'react'
import {
    returnCardInformation,
    raiseSelectItemEvent,
} from '@news-mono/web-common'
import { IconNextGenPerthNowComment } from '../../../../../icons/IconNextGenPerthNowComment/IconNextGenPerthNowComment'
import {
    StyledFooter,
    StyledCommentAnchor,
    StyledAuthor,
    StyledAuthorCommentGroup,
} from './PNArticleCardFooter.styled'
import { PNArticleCardProps } from '../PNArticleCard'

/**
 * A React functional component that renders the footer of a news article card.
 *
 * @param props - The component's props.
 * @param props.item - The data item containing the article information.
 * @param props.cardType - The type of the card.
 *
 * @returns A React element representing the footer of the news article card.
 */

export const PNArticleCardFooter: React.FC<PNArticleCardProps> = (props) => {
    const {
        item,
        onEvent,
        cardType,
        fontScale = 'M',
        cardNumber,
        showAuthor = false,
    } = props

    if (item.loaded) {
        const { result } = item
        const { link, allowCommenting = false, _self, byline } = result

        const cardInfo = returnCardInformation(result)

        // Helper that fires the select_item list event
        const linkClicked = (originator: string) => {
            raiseSelectItemEvent(
                onEvent,
                originator,
                cardInfo,
                result,
                cardNumber,
            )
        }

        return (
            <StyledFooter
                role="contentinfo"
                data-card-type={cardType}
                data-font-scale={fontScale}
            >
                <StyledAuthorCommentGroup>
                    {showAuthor && byline && (
                        <StyledAuthor hasDivider={allowCommenting}>
                            {byline}
                        </StyledAuthor>
                    )}
                    {allowCommenting && (
                        <StyledCommentAnchor
                            to={`${link}#coral_thread`}
                            aria-label="Comments count"
                            tabIndex={0}
                            onClick={() =>
                                linkClicked('pn-article-card-comments')
                            }
                        >
                            <span>
                                {_self && (
                                    <span
                                        className="coral-count"
                                        data-coral-url={_self}
                                        data-coral-notext={true}
                                        dangerouslySetInnerHTML={{
                                            __html: '',
                                        }} // Bypass hydration overwriting the span
                                        suppressHydrationWarning
                                    ></span>
                                )}
                                <IconNextGenPerthNowComment />
                            </span>
                        </StyledCommentAnchor>
                    )}
                </StyledAuthorCommentGroup>
            </StyledFooter>
        )
    }

    // Return null if the item is not loaded
    return null
}
